import React, {Component} from "react";
import YesNoNotAvailableEnum from "../../../../../genericenums/YesNoNotAvailableEnum";

export default class BirthViewHistory extends Component {
    render() {
        if (this.props.birthHistory == null) {
            return <div className="pl-3">No information available</div>;
        }

        let birthHistoryData = this.getBirthHistoryData();
        return (
            <div className="pl-3">
                {birthHistoryData}
            </div>
        )
    }

    getBirthHistoryData() {
        let divs = [];

        if (this.props.birthHistory.currentlyPregnant != null) {
            divs.push(
                <div key={"birthViewHistoryDivPregnant"}>
                    <b>Currently
                        Pregnant:</b> {YesNoNotAvailableEnum[this.props.birthHistory.currentlyPregnant].name}{this.props.birthHistory.currentlyPregnantDetail == null ? '' : (", " + this.props.birthHistory.currentlyPregnantDetail)}
                </div>);
        }

        return divs;
    }
}